export const careTypeTitleCopy = (careType, locationName) =>
  ({
    care_home: `How are care homes in ${locationName} regulated?`,
    home_care: `How are homes care agencies in ${locationName} regulated?`,
    agnostic: `How are care providers in ${locationName} regulated?`,
  }[careType])

export const regulatoryBodyCopy = (regulatoryBody) =>
  ({
    cqc: "Care Quality Commission (CQC)",
    ci: "Care Inspectorate (CI)",
  }[regulatoryBody])

export const careTypeParagraphCopy = (pageType, locationName, regulatoryBody) =>
  ({
    care_home: `All care homes in ${locationName} are regulated by the ${regulatoryBodyCopy(
      regulatoryBody,
    )}.`,
    home_care: `All home care agencies in ${locationName} are regulated by the ${regulatoryBodyCopy(
      regulatoryBody,
    )}.`,
    agnostic: `All care providers in ${locationName} are regulated by the ${regulatoryBodyCopy(
      regulatoryBody,
    )}.`,
    dementia: `All dementia care homes in ${locationName} are regulated by the ${regulatoryBodyCopy(
      regulatoryBody,
    )}.`,
  }[pageType])

export const positivelyRatedParagraphCopy = (
  careTypeString,
  locationName,
  totalProviderCount,
  positivelyRatedCount,
) =>
  ({
    0: `Of the ${totalProviderCount} ${careTypeString} in ${locationName}, none have been rated good or above`,
    1: `Of the ${totalProviderCount} ${careTypeString} in ${locationName}, 1 has been rated good or above`,
    [totalProviderCount]: `Of the ${totalProviderCount} ${careTypeString} in ${locationName}, all have been rated good or above`,
  }[positivelyRatedCount] ||
  `Of the ${totalProviderCount} ${careTypeString} in ${locationName}, ${positivelyRatedCount} have been rated good or above`)
